var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("header", { staticClass: "elHeader" }, [
      _c("img", { attrs: { src: _vm.logoSrc } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightbtn" },
        [
          _c("afterMsgPop"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "280",
                    trigger: "click"
                  },
                  model: {
                    value: _vm.popoverVisible,
                    callback: function($$v) {
                      _vm.popoverVisible = $$v
                    },
                    expression: "popoverVisible"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "my-popover" },
                    [
                      _c("popoverTitle", {
                        on: {
                          onSearch: _vm.onAlertMsgSearch,
                          onChange: _vm.onSearchClear
                        }
                      }),
                      _vm._v(" "),
                      _vm.alertMsgLists.length === 0
                        ? _c(
                            "div",
                            { staticClass: "my-popover empty-wrapper" },
                            [
                              _c("img", {
                                attrs: { src: _vm.noData, alt: "" }
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("暂无数据")])
                            ]
                          )
                        : _c("popoverContent", {
                            attrs: { lists: _vm.alertMsgLists },
                            on: { onJumpto: _vm.onJumpto }
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-badge",
                    {
                      attrs: {
                        slot: "reference",
                        "is-dot": _vm.forAlertLists.length > 0
                      },
                      slot: "reference"
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v("\n              锐锢在线\n            ")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.ifNews,
                    callback: function($$v) {
                      _vm.ifNews = $$v
                    },
                    expression: "ifNews"
                  }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { color: "#d7dee4", "font-size": "13px" } },
                    [_vm._v(" 新订单提醒 ")]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-badge",
                {
                  attrs: {
                    value: _vm.sysMessage.length,
                    "is-dot": "",
                    hidden: _vm.sysMessage.length === 0
                  }
                },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        width: "600",
                        trigger: "click",
                        offset: 30
                      },
                      on: { show: _vm.show, hide: _vm.hide }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: !_vm.showMessage,
                              expression: "!showMessage"
                            }
                          ],
                          staticClass: "message-wrap",
                          style: { "min-height": _vm.minheight }
                        },
                        [
                          _vm.showMessage
                            ? _c(
                                "div",
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _c("div", [_vm._v("新消息通知")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              change: _vm.changeRadioMessage
                                            },
                                            model: {
                                              value: _vm.radioMessage,
                                              callback: function($$v) {
                                                _vm.radioMessage = $$v
                                              },
                                              expression: "radioMessage"
                                            }
                                          },
                                          [
                                            _c("el-radio-button", {
                                              attrs: { label: "未读消息" }
                                            }),
                                            _vm._v(" "),
                                            _c("el-radio-button", {
                                              attrs: { label: "已读消息" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.radioMessage === "未读消息"
                                    ? _c(
                                        "el-collapse",
                                        { attrs: { accordion: "" } },
                                        [
                                          _vm._l(_vm.sysMessage, function(
                                            item
                                          ) {
                                            return _c("div", { key: item.id }, [
                                              item.list
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "message-item-el-collapse"
                                                    },
                                                    [
                                                      _c(
                                                        "el-collapse-item",
                                                        {
                                                          attrs: {
                                                            name: item.id
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "title" },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "message-item"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "message-item-head"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                item.typeName
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "no-mark",
                                                                              staticStyle: {
                                                                                "font-size":
                                                                                  "12px"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.created_at
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "mark",
                                                                              staticStyle: {
                                                                                "font-size":
                                                                                  "12px"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.readMessage(
                                                                                    item
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  attrs: {
                                                                                    type:
                                                                                      "text"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "标记已读"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "message-item-content"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              定时同步库存错误\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            item.list,
                                                            function(detail) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    detail.sku_code,
                                                                  staticClass:
                                                                    "message-item-kucun"
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "sku:" +
                                                                        _vm._s(
                                                                          detail.sku_code
                                                                        ) +
                                                                        ":"
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "定时同步库存错误"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "message-item",
                                                      staticStyle: {
                                                        "border-bottom":
                                                          "1px solid #ebeef5"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "message-item-head common-message"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  item.typeName
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "no-mark",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.created_at
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mark",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.readMessage(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "text"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "标记已读"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "message-item-content"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.content
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _vm.sysMessage.length === 0
                                            ? _c(
                                                "div",
                                                { staticClass: "no-message" },
                                                [
                                                  _vm._v(
                                                    "\n                    暂无未读消息\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _c(
                                        "el-collapse",
                                        { attrs: { accordion: "" } },
                                        [
                                          _vm._l(_vm.sysReadMessage, function(
                                            item
                                          ) {
                                            return _c("div", { key: item.id }, [
                                              item.list
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "message-item-el-collapse"
                                                    },
                                                    [
                                                      _c(
                                                        "el-collapse-item",
                                                        {
                                                          attrs: {
                                                            name: item.id
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "title" },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "message-item"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "message-item-head"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                item.typeName
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "no-mark",
                                                                              staticStyle: {
                                                                                "font-size":
                                                                                  "12px"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.created_at
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "mark",
                                                                              staticStyle: {
                                                                                "font-size":
                                                                                  "12px"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteMessage(
                                                                                    item
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticStyle: {
                                                                                    "font-size":
                                                                                      "12px",
                                                                                    color:
                                                                                      "red"
                                                                                  },
                                                                                  attrs: {
                                                                                    type:
                                                                                      "text"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "删除已读"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "message-item-content"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              定时同步库存错误\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            item.list,
                                                            function(detail) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    detail.sku_code,
                                                                  staticClass:
                                                                    "message-item-kucun"
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "sku:" +
                                                                        _vm._s(
                                                                          detail.sku_code
                                                                        ) +
                                                                        ":"
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "定时同步库存错误"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "message-item",
                                                      staticStyle: {
                                                        "border-bottom":
                                                          "1px solid #ebeef5"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "message-item-head common-message"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  item.typeName
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "no-mark",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.created_at
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mark",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteMessage(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticStyle: {
                                                                      "font-size":
                                                                        "12px",
                                                                      color:
                                                                        "red"
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "text"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "删除已读"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "message-item-content"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.content
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _vm.sysReadMessage.length === 0
                                            ? _c(
                                                "div",
                                                { staticClass: "no-message" },
                                                [
                                                  _vm._v(
                                                    "\n                    暂无已读消息\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: { "font-size": "12px" },
                          attrs: { slot: "reference" },
                          slot: "reference"
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-bell",
                            staticStyle: { "font-size": "12px" }
                          }),
                          _vm._v("消息")
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "span",
              {
                staticClass: "logout",
                staticStyle: { "font-size": "12px" },
                on: { click: _vm.logout }
              },
              [
                _c("i", {
                  staticClass: "iconfont icon-tuichu",
                  staticStyle: { "font-size": "12px" }
                }),
                _vm._v("退出")
              ]
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.showAsDiglog ? _c("div", [_c("PendingAsOrderDialog")], 1) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30de9f9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30de9f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
// module id = null
// module chunks = 